import { useQuery } from '@tanstack/react-query';
import { fetchHealth } from './api';

export function HealthCard() {
  const health = useQuery({
    queryKey: ['health'],
    queryFn: ({ signal }) => fetchHealth(signal),
    refetchInterval: 30_000,
    retry: 1,
  });

  if (health.isPending) {
    return (
      <section className="card" role="status" aria-live="polite" data-state="loading">
        <p className="card-title">Checking the server…</p>
      </section>
    );
  }

  if (health.isError) {
    return (
      <section className="card card-bad" role="status" aria-live="polite" data-state="unreachable">
        <p className="card-title">
          <span className="dot dot-bad" aria-hidden="true" /> Can't reach the server
        </p>
        <p className="card-detail">Check your connection, then try again.</p>
        <button type="button" onClick={() => void health.refetch()}>
          Try again
        </button>
      </section>
    );
  }

  const h = health.data;
  if (h.status === 'ok') {
    return (
      <section className="card card-good" role="status" aria-live="polite" data-state="healthy">
        <p className="card-title">
          <span className="dot dot-good" aria-hidden="true" /> Server and database healthy
        </p>
        <dl className="facts">
          <dt>Server version</dt>
          <dd>{h.version}</dd>
          <dt>Database</dt>
          <dd>Postgres {h.db.postgresVersion?.split(' ')[0]}</dd>
          <dt>Vancouver time</dt>
          <dd>UTC{h.time.vancouverOffsetNode}</dd>
        </dl>
      </section>
    );
  }

  const problems = [...(h.db.error ? [h.db.error] : []), ...h.time.problems];
  return (
    <section className="card card-warn" role="status" aria-live="polite" data-state="degraded">
      <p className="card-title">
        <span className="dot dot-warn" aria-hidden="true" /> Something needs attention
      </p>
      <ul className="problems">
        {problems.map((p) => (
          <li key={p}>{p}</li>
        ))}
      </ul>
      <button type="button" onClick={() => void health.refetch()}>
        Check again
      </button>
    </section>
  );
}
